<template>
  <main class="screen">
    <div class="wrap">
      <h1>請掃描販賣機 QR 碼</h1>
      <p>網址需包含販賣機編號,例如:</p>
      <code>/qr/INT250100001</code>
    </div>
  </main>
</template>

<style scoped>
.screen {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
}
.wrap {
  text-align: center;
  padding: 24px;
}
h1 {
  font-size: 20px;
  color: #111827;
}
p {
  color: #6b7280;
}
code {
  display: inline-block;
  margin-top: 8px;
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 14px;
}
</style>
